import './App.css';
import './components/enrollment'
import EnrollmentPanel from './components/enrollment-panel';

function App() {
  return (
    <div className="App">
      <EnrollmentPanel />
    </div>
  );
}

export default App;
